<template>
	<div v-if="visible" class="financial-overlay" @click.self="handleClose">
		<div class="financial-container">
			<!-- 关闭按钮 -->
			<button class="close-btn" @click="handleClose">
				<i class="el-icon-close"></i>
			</button>
			
			<!-- 标题和历史记录按钮 -->
			<div class="financial-header">
				<h2 class="financial-title">{{ $t('Financial.title') || '理财产品' }}</h2>
				<button class="history-btn" @click="handleShowHistory">
					{{ $t('Financial.records') || '历史记录' }}
				</button>
			</div>
			
			<!-- 产品列表 -->
			<div v-if="loading" class="loading-container">
				<i class="el-icon-loading" style="font-size: 32px; color: var(--primary-color, #0156DC);"></i>
				<div style="margin-top: 10px;">{{ $t('common.loading') || '加载中...' }}</div>
			</div>
			
			<div v-else-if="productList.length > 0" class="products-grid">
				<div 
					v-for="(product, index) in productList" 
					:key="index"
					class="product-card"
				>
					<div class="product-header">
						<div class="product-icon-wrapper">
							<img :src="product.logo || defaultImage" @error="handleImageError($event)" class="product-icon-img" />
						</div>
						<div class="product-name">{{ product.name }}</div>
					</div>
					
					<div class="product-info">
						<div class="info-item">
							<div class="info-label">{{ $t('Financial.subscriptionPrice') || '认购价格' }}</div>
							<div class="info-value">{{ product.min }}-{{ product.max }}</div>
						</div>
						<div class="info-item">
							<div class="info-label">{{ $t('Financial.yieldRate') || '收益率' }}</div>
							<div class="info-value rate">{{ product.rate }}%</div>
						</div>
					</div>
					
					<button class="detail-btn" @click="handleShowDetail(product)">
						{{ $t('Financial.detail') || '产品详情' }}
					</button>
				</div>
			</div>
			
			<div v-else class="empty-state">
				<div class="empty-icon">📊</div>
				<div class="empty-text">{{ $t('Financial.noProducts') || '暂无理财产品' }}</div>
			</div>
		</div>
		
		<!-- 产品详情弹窗 -->
		<FinancialDetail
			v-if="detailVisible"
			:visible="detailVisible"
			:product="selectedProduct"
			:userBalance="userBalance"
			@close="detailVisible = false"
			@purchase="handlePurchase"
		/>
		
		<!-- 历史记录弹窗 -->
		<FinancialHistory
			v-if="historyVisible"
			:visible="historyVisible"
			@update:visible="historyVisible = $event"
		/>
	</div>
</template>

<script>
import FinancialDetail from './FinancialDetail.vue';
import FinancialHistory from './FinancialHistory.vue';

export default {
	name: 'FinancialProducts',
	components: {
		FinancialDetail,
		FinancialHistory
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		productList: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: false
		},
		userBalance: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			detailVisible: false,
			historyVisible: false,
			selectedProduct: null,
			defaultImage: 'data:image/png;base64,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'
		};
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
			this.$emit('close');
		},
		
		handleShowDetail(product) {
			this.selectedProduct = product;
			this.detailVisible = true;
		},
		
		handleShowHistory() {
			this.historyVisible = true;
		},
		
		handlePurchase(data) {
			this.$emit('purchase', data);
			this.detailVisible = false;
		},
		
		// 图片加载失败时使用默认图片
		handleImageError(event) {
			event.target.src = this.defaultImage;
		}
	}
};
</script>

<style scoped>
/* 遮罩层 */
.financial-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: var(--modal-overlay-bg, rgba(0, 0, 0, 0.5));
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	transition: all 0.3s ease;
}

/* 容器 */
.financial-container {
	width: 900px;
	max-width: 95vw;
	max-height: 85vh;
	background: var(--card-bg, #ffffff);
	border-radius: 16px;
	box-shadow: var(--modal-shadow, 0 8px 32px rgba(0, 0, 0, 0.12));
	overflow-y: auto;
	position: relative;
	padding: 40px;
	transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* 关闭按钮 */
.close-btn {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 50%;
	background: var(--bg-secondary, #f5f5f5);
	color: var(--text-secondary, #666);
	border: none;
	transition: all 0.3s ease;
	z-index: 10;
}

.close-btn:hover {
	background: var(--hover-bg, rgba(0, 0, 0, 0.1));
	color: var(--text-primary, #333);
}

.close-btn i {
	font-size: 18px;
}

/* 标题区域 */
.financial-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 30px;
}

.financial-title {
	font-size: 24px;
	font-weight: 600;
	color: var(--text-primary, #333);
	margin: 0;
	transition: color 0.3s ease;
}

.history-btn {
	background: var(--primary-color, #0156DC);
	color: white;
	border: none;
	border-radius: 8px;
	padding: 10px 20px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
}

.history-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 加载状态 */
.loading-container {
	text-align: center;
	padding: 60px 20px;
	color: var(--text-secondary, #666);
}

/* 产品网格 */
.products-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: 20px;
}

/* 产品卡片 */
.product-card {
	background: var(--bg-secondary, #f9f9f9);
	border: 1px solid var(--border-light, #e8e8e8);
	border-radius: 12px;
	padding: 20px;
	transition: all 0.3s ease;
}

.product-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
	border-color: var(--primary-color, #0156DC);
}

.product-header {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 20px;
}

.product-icon-wrapper {
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--card-bg, #ffffff);
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	flex-shrink: 0;
}

.product-icon-img {
	width: 40px;
	height: 40px;
	object-fit: contain;
	border-radius: 8px;
}

.product-name {
	font-size: 18px;
	font-weight: 600;
	color: var(--text-primary, #333);
	transition: color 0.3s ease;
}

.product-info {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

.info-item {
	flex: 1;
}

.info-label {
	font-size: 12px;
	color: var(--text-secondary, #666);
	margin-bottom: 5px;
	transition: color 0.3s ease;
}

.info-value {
	font-size: 16px;
	font-weight: 600;
	color: var(--text-primary, #333);
	transition: color 0.3s ease;
}

.info-value.rate {
	font-size: 20px;
	color: var(--primary-color, #0156DC);
}

.detail-btn {
	width: 100%;
	height: 42px;
	background: var(--primary-color, #0156DC);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
}

.detail-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 空状态 */
.empty-state {
	text-align: center;
	padding: 60px 20px;
	color: var(--text-secondary, #999);
}

.empty-icon {
	font-size: 64px;
	margin-bottom: 15px;
}

.empty-text {
	font-size: 16px;
	transition: color 0.3s ease;
}

/* 滚动条样式 */
.financial-container::-webkit-scrollbar {
	width: 6px;
}

.financial-container::-webkit-scrollbar-track {
	background: var(--bg-secondary, #f5f5f5);
	border-radius: 3px;
}

.financial-container::-webkit-scrollbar-thumb {
	background: var(--border-color, #dcdfe6);
	border-radius: 3px;
}

.financial-container::-webkit-scrollbar-thumb:hover {
	background: var(--text-tertiary, #999);
}

/* 响应式 */
@media (max-width: 768px) {
	.financial-container {
		width: 95vw;
		padding: 20px;
	}
	
	.products-grid {
		grid-template-columns: 1fr;
	}
}
</style>

